"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidEditionParamMsg = exports.missingPrepUrlParamErrorMsg = exports.missingPlatformParamErrorMsg = exports.invalidUrlErrorMsg = void 0;
exports.invalidUrlErrorMsg = 'Invalid URL.';
exports.missingPlatformParamErrorMsg = 'Server or Online Help URLs require a platform parameter.';
exports.missingPrepUrlParamErrorMsg = 'Prep Help URLs require a platform parameter and a build parameter';
exports.invalidEditionParamMsg = 'Invalid edition parameter, please provide one of the following: prep, pro, reader, online, server, tableau-mobile-phoenix';
//# sourceMappingURL=HelpLinkLibraryStrings.js.map